export default __webpack_public_path__ + "static/media/logo5.f1fee1ce.jpg";